import SSContainer from "@core-components/container/Container";
import { Outlet } from "react-router";

const PublicLayout: React.FC = () => (
  <div className="relative mb-20 min-h-full md:mb-40">
    <SSContainer>
      <Outlet />
    </SSContainer>
  </div>
);

export default PublicLayout;
